import { FAQS_LOADED_FOR_COURSE, FAQS_LOADING, FAQS_LOADING_FAILED } from '../actions/types';

const initialState = {
    loading: false,
    faqs: [],
};

export default function faqs(state = initialState, action) {
    switch (action.type) {
        case FAQS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case FAQS_LOADED_FOR_COURSE:
            let newFaqs = state.faqs;
            action.payload.forEach((faq) => {
                if (!newFaqs.find((f) => f._id === faq._id)) newFaqs.push(faq);
            });

            return {
                ...state,
                faqs: newFaqs,
                loading: false,
            };

        case FAQS_LOADING_FAILED:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}
